<div class="upload-progress-container" [ngClass]="{'has-promotion': hasPromotion}">
    <div class="upload-progress-body">
        <div class="circular-progress-container">
            <div class="logo-safe-container">
                <app-smash-circular-progress [progress]="100"></app-smash-circular-progress>
            </div>
        </div>
        <div class="upload-status-container" [@fade] *ngIf="!!dropbox">
            <div class="upload-status" [innerHtml]="'UPLOADER_DROPBOX_CREATED_LINK_TITLE' | translate | safeHtml"></div>
            <div class="upload-description" translate [innerHtml]="'UPLOADER_DROPBOX_CREATED_LINK_TEXT' | translate: { maxTransferCount: dropbox.maxTransferCount } | safeHtml"></div>

            <div class="upload-link" (click)="copyLink()">
                <div class="input-container">
                    <app-smash-input borderStyle="full" [copyEnabled]="true" readonly="true" type="text" [value]="link"></app-smash-input>
                    <div class="upload-button-copy-link-copied" *ngIf="dropboxUrlCopied">{{ 'UPLOADER_COPY_LINK_COPIED' |
                        translate }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="upload-footer" *ngIf="!!dropbox">
        <div class="upload-footer-wrapper">
            <div class="combo">
                <ul class="dropdown smash-suggest-list-container" [ngClass]="{ 'menuExpanded' : menuExpanded }">
                    <li class="smash-suggest link">
                        <a [href]="link" target="_blank">{{ 'UPLOADER_SEND_BUTTON_LABEL_SEE_DROPBOX_LINK' | translate }}</a>
                    </li>
                    <li class="smash-suggest" (click)="makeNewDropbox()">
                        {{ 'UPLOADER_DROPBOX_CREATED_BUTTON_LABEL_AGAIN' | translate }}
                    </li>
                    <li class="smash-suggest link" *ngIf="showDiscoverSmash">
                        <a id="link-send-upgrade-to-premium" href="{{ 'UPLOADER_SEND_LINK_PREMIUM' | translate }}" target="_blank">{{
                            'UPLOADER_SEND_BUTTON_LABEL_DISCOVER_SMASH_PREMIUM' | translate }}</a>
                    </li>
                    <li class="smash-suggest link">
                        <a [routerLink]="['/account/team/' + selectedTeam.id + '/transfers/received']">{{
                            'UPLOADER_SEND_BUTTON_LABEL_ACCESS_MY_ACCOUNT' | translate }}</a>
                    </li>
                </ul>

                <label class="red" for="">
                    <div (click)="copyLink()">{{ 'UPLOADER_COPY_LINK' | translate }}</div>
                </label>
                <button class="combo-btn red" (click)="expandMenu()">
                    <i class="icon-smash_expand_arrow " [ngClass]="{ 'menuExpanded' : menuExpanded }"></i>
                </button>
            </div>
        </div>
    </div>
</div>